'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fass';
var iconName = 'file-csv';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'f6dd';
var svgPathData = 'M272 0l-240 0 0 512 144 0 0-176 240 0 0-192-144-144zm85.5 176L240 176 240 58.5 357.5 176zM264 380c-24.3 0-44 19.7-44 44l0 80c0 24.3 19.7 44 44 44l16 0c24.3 0 44-19.7 44-44l0-16-40 0 0 16c0 2.2-1.8 4-4 4l-16 0c-2.2 0-4-1.8-4-4l0-80c0-2.2 1.8-4 4-4l16 0c2.2 0 4 1.8 4 4l0 16 40 0 0-16c0-24.3-19.7-44-44-44l-16 0zm136 0c-28.7 0-52 23.3-52 52s23.3 52 52 52c6.6 0 12 5.4 12 12s-5.4 12-12 12l-52 0 0 40 52 0c28.7 0 52-23.3 52-52s-23.3-52-52-52c-6.6 0-12-5.4-12-12s5.4-12 12-12l44 0 0-40-44 0zm116 0l-40 0 0 55c0 21.6 3.9 43 11.5 63.2 10.7 28.5 16.9 45.1 18.7 49.8l43.7 0c1.8-4.7 8-21.3 18.7-49.8 7.6-20.2 11.5-41.6 11.5-63.2l0-55-40 0 0 55c0 16.8-3 33.4-8.9 49.2l-3.1 8.2-3.1-8.2C519 468.4 516 451.8 516 435l0-55z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFileCsv = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;